import React, { CSSProperties, FC, ReactElement } from 'react';
import { DropdownCont, MenuCont } from './Dropdown.styles';
import Checkbox from '../Checkbox/Checkbox';

interface IDropdown {
  options: string[];
  selectedItems: string[];
  icon: ReactElement;
  onSelect: (option: string[]) => void;
  onDeselect: (option: string[]) => void;
  style?: CSSProperties;
}

const Dropdown: FC<IDropdown> = ({
  options,
  icon,
  selectedItems,
  onSelect,
  onDeselect,
  style = {},
}) => {
  const menu = {
    selectable: true,
    multiple: true,
    defaultSelectedKeys: selectedItems.map(item => `${options.indexOf(item)}`),
    items: options.map((option: string, index: number) => ({
      label: option,
      key: `${index}`,
      'data-testid': 'menu-item',
      icon: <Checkbox checked={selectedItems.includes(option)} />,
    })),
    onSelect: ({ selectedKeys }: { selectedKeys: string[] }) =>
      onSelect(selectedKeys.map(key => options[parseInt(key)])),
    onDeselect: ({ selectedKeys }: { selectedKeys: string[] }) =>
      onDeselect(selectedKeys.map(key => options[parseInt(key)])),
    style,
  };

  return (
    <DropdownCont menu={menu} trigger={['click']} placement="bottom" data-testid="dropdown-menu">
      <a onClick={e => e.preventDefault()} data-testid="dropdown-container">
        {icon}
      </a>
    </DropdownCont>
  );
};

export default Dropdown;
